import { z } from 'zod';

export const retryFailedUploadsResponseSchema = z.object({
  retried: z.number(),
});

export type IRetryFailedUploadsResponse = z.infer<typeof retryFailedUploadsResponseSchema>;
